import { Row } from "react-bootstrap";
import {
  ConfigurationSectionType,
  GetConfigurationSections,
  IConfigurationSection,
} from "../../assets/configuration/configurationSections";
import {
  IConfigurationStyles,
  PageContent,
  useConfigurationStyles,
} from "../../assets/layouts";
import { ConfigurationSection } from "../../assets/vfx/configuration";
import { CommunityService } from "../community/communityService";
import { SearchDto } from "../../services/dto";
import React from "react";
import { defaultControlledSearchQuery, sortBy } from "../../assets/types";

export interface IConfiguationSettingsProps {
  sectionType: ConfigurationSectionType;
}

export const ConfiguationSettings = (props: IConfiguationSettingsProps) => {
  const [searchQuery, setSearchQuery] = React.useState<SearchDto>({
    ...defaultControlledSearchQuery,
    sortBy: defaultControlledSearchQuery.sortBy ?? sortBy,
    sorts: defaultControlledSearchQuery.sorts ?? [
      defaultControlledSearchQuery.sortBy ?? sortBy,
    ],
  });

  const userCommunities = CommunityService.getUserCommunities().data;
  const sections = GetConfigurationSections({ userCommunities });
  const styles: IConfigurationStyles = useConfigurationStyles();
  const filteredSections = sections?.filter(function (x) {
    return (
      (x.isDisplayed || x.isDisplayed === undefined) &&
      x.sectionType === props.sectionType
    );
  });

  return (
    <>
      {filteredSections !== null &&
        filteredSections !== undefined &&
        filteredSections.length > 0 && (
          <PageContent title={filteredSections[0].title}>
            <div style={{ height: "auto" }}>
              <Row>
                {filteredSections.map(
                  (section: IConfigurationSection, index: number) => (
                    <div key={index}>
                      <ConfigurationSection
                        {...section}
                        controlStyles={styles}
                        showTitle={false}
                      />
                    </div>
                  )
                )}
              </Row>
            </div>
          </PageContent>
        )}
    </>
  );
};
